<script setup lang="ts">
import { computed, toRef } from "vue";
import { useCardLocalOptions } from "@/composables/useCardLocalOptions";
import ColorToggleField from "./CardOptionFields/ColorToggleField.vue";
import PopulationField from "./CardOptionFields/PopulationField.vue";
import ScoreMatrixField from "./CardOptionFields/ScoreMatrixField.vue";
import { useCardPopulation } from "./analysisData";
import OptionSection from "./CardOptionFields/OptionSection.vue";

const props = defineProps({
  card: { type: Object, required: true },
});

const card = toRef(props, "card");
const { localOptions, updateLocalOption } = useCardLocalOptions(card);
const { color: populationColor } = useCardPopulation(card);

const accentColor = computed({
  get: () => localOptions.value.color || null,
  set: (value: string | null) => updateLocalOption("color", value),
});
</script>

<template>
  <OptionSection
    id="data"
    title="Data">
    <ScoreMatrixField :card="card" />
    <PopulationField :card="card" />
  </OptionSection>

  <OptionSection
    id="display"
    title="Display"
    :count="accentColor ? 1 : 0">
    <ColorToggleField
      v-model="accentColor"
      :default-color="populationColor"
      hint="Color of the bars. It starts as the color of its population." />
  </OptionSection>
</template>
